import { styled } from '@mui/material/styles'
import { TextField, Stack, IconButton, Box } from '@mui/material'

export const StyledTextField = styled(TextField)({
  flex: 2,
  height: '36px',
  backgroundColor: 'white',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#EFEFEF',
    borderRadius: '32px'
  },
  '& .MuiOutlinedInput-root': {
    height: '36px',
    borderRadius: '32px',
    '&:hover fieldset': {
      borderColor: '#EFEFEF'
    },
    '&:focus-within fieldset, &:focus-visible fieldset': {
      borderColor: 'primary.main',
      borderWidth: '1px'
    }
  },
  '& .MuiInputAdornment-root': {
    maxWidth: 'none',
    width: 'auto'
  },
  '& .MuiInputAdornment-positionEnd': {
    transform: 'translateX(3px)'
  }
})

export const StyledLocationAdornment = styled(Box, {
  shouldForwardProp: prop => prop !== 'isfocused'
})(({ theme, isfocused }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: isfocused ? theme.palette.primary.main : theme.palette.text.body.secondary,
  fontSize: '16px',
  borderRight: `1px solid ${theme.palette.border.primary}`,
  paddingRight: theme.spacing(1),
  flex: '0 0 auto'
}))

export const StyledClearIcon = styled('i')(({ theme }) => ({
  backgroundColor: theme.palette.surface.tertiary,
  color: theme.palette.text.body.secondary,
  fontSize: '10px',
  borderRadius: '50%',
  width: '18px',
  height: '18px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}))

export const StyledIconButton = styled(IconButton)({
  fontSize: '15px',
  color: 'content.dimmed',
  padding: 0
})

export const StyledStack = styled(Stack)({
  flexShrink: 0,
  width: 'auto'
})
